import { getBoundaryCoordinates } from "../services/v2/wantAdService";
import { useState, useEffect, useRef } from "react";
import _ from "lodash";

// Module-level cache so polygon data persists across component mounts/navigations
const polygonCache = new Map();

const getCacheKey = (zipCode) => {
  if (!Array.isArray(zipCode) || zipCode.length === 0) return null;
  return zipCode
    .map((item) => item?.zipCode)
    .filter(Boolean)
    .sort()
    .join(",");
};

const usePolygons = (zipCode, disable = true) => {
  const hasZips = !disable && Array.isArray(zipCode) && zipCode.length > 0;
  const cacheKey = getCacheKey(zipCode);
  const cached = cacheKey ? polygonCache.get(cacheKey) : null;

  const [polygonCoordinates, setPolygonCoordinates] = useState(cached || []);
  // Start loading if we have zips to fetch and no cache hit
  const [isLoading, setIsLoading] = useState(hasZips && !cached);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  const setBoundaryCoordinates = (zipCode) => {
    if (_.isEmpty(zipCode)) return;

    const key = getCacheKey(zipCode);

    // Return cached data immediately
    if (key && polygonCache.has(key)) {
      const cachedData = polygonCache.get(key);
      setPolygonCoordinates(cachedData);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    var payload = [];
    zipCode?.map(function (item) {
      payload.push(item?.zipCode);
    });

    getBoundaryCoordinates({ zipCode: payload })
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        if (response.errorCode === 0 && responseResult) {
          let coordinates = [];
          let zipValues = [];
          responseResult.map((result) => {
            zipValues.push({ zipCode: result?.ZipCode, zipId: result?.ZipId });

            coordinates.push([result?.coordinates]);
          });
          // Cache the result
          if (key) {
            polygonCache.set(key, coordinates);
          }
          if (mountedRef.current) {
            setPolygonCoordinates(coordinates);
          }
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      })
      .finally(() => {
        if (mountedRef.current) {
          setIsLoading(false);
        }
      });
  };

  useEffect(() => {
    if (!disable) {
      setBoundaryCoordinates(zipCode);
    }
  }, [zipCode, disable]);

  return { polygonCoordinates, isLoading };
};

export default usePolygons;
